module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/73773f78bf2bfc449218fbaee1922964.svg";